import React, { useState } from "react";
import styles from "./SpinConnectDownload.module.scss";
import spinConnectLogo from "../../static/icons/spinconnecticon.svg";

import windowsIcon from "../../static/icons/windowsicon.svg";
import macIcon from "../../static/icons/MacIcon.svg";
import backArrowIcon from "../../static/icons/back-long.svg";
import { useSelector } from "react-redux";
import MobileMobal from "../Modal/MobileModal";

const SpinConnectDownload = ({ match, location, isPublic }) => {
  const { userInfo } = useSelector((state) => state.authReducer);
  const [mobileMessage, setMobileMessage] = useState(false);

  const topText = !userInfo ? "LOG-IN" : "SUBSCRIPTIONS";

  const handleMacDownload = async () => {
    const yml = await fetch(
      "https://spinos-releases.s3.us-east-1.amazonaws.com/macos-signed-latest/latest-mac.yml"
    ).then((r) => r.text());
    const { fileName, fileLink } = getFileNameLink(
      /url:.*.dmg/gm,
      "macos",
      yml
    );
    startDownload(fileName, fileLink);
  };
  const handleWindowsDownload = async () => {
    const yml = await fetch(
      "https://spinos-releases.s3.us-east-1.amazonaws.com/windows-signed-latest/latest.yml"
    ).then((r) => r.text());
    const { fileName, fileLink } = getFileNameLink(
      /url:.*.exe/gm,
      "windows",
      yml
    );
    startDownload(fileName, fileLink);
  };

  const startDownload = (fileName, fileLink) => {
    const link = document.createElement("a");
    link.href = fileLink;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const getFileNameLink = (r, system, yml) => {
    const fileName = yml.match(r)[0].replace("url: ", "");
    const fileLink = `https://spinos-releases.s3.us-east-1.amazonaws.com/${system}-signed-latest/${fileName}`;
    return { fileName, fileLink };
  };

  const handleClick = ({ fromWindows }) => {
    const downloadConnect = () => {
      if (fromWindows) {
        handleWindowsDownload();
      } else {
        handleMacDownload();
      }
    };

    // Check for mobile devices
    if (window.innerWidth < 1000) {
      setMobileMessage(true);
      return;
    }

    // Attempt to open Spin OS via custom protocol
    const appProtocol = "spinconnect://";
    const hiddenIframe = document.createElement("iframe");
    hiddenIframe.style.display = "none";
    hiddenIframe.src = appProtocol;
    document.body.appendChild(hiddenIframe);

    let opened = false;
    const visibilityChange = () => {
      if (document.hidden) {
        opened = true;
      }
    };
    document.addEventListener("visibilitychange", visibilityChange);

    setTimeout(() => {
      document.body.removeChild(hiddenIframe);
      document.removeEventListener("visibilitychange", visibilityChange);

      if (!opened) {
        downloadConnect();
      }
    }, 1000);
  };

  const openSpinOSOnLoad = () => {
    if (window.innerWidth < 1000) {
      return;
    }

    const appProtocol = "spinconnect://";
    const hiddenIframe = document.createElement("iframe");
    hiddenIframe.style.display = "none";
    hiddenIframe.src = appProtocol;
    document.body.appendChild(hiddenIframe);

    setTimeout(() => {
      document.body.removeChild(hiddenIframe);
    }, 1000);
  };

  window.onload = openSpinOSOnLoad;



  return (
    <div>
      {mobileMessage && (
        <MobileMobal
          onClose={() => {
            setMobileMessage(false);
          }}
        />
      )}
      <div className={styles.SpinConnectDownload}>
        <div className={styles.SpinConnectDownload__TopHeader}>
          <div className={styles.SpinConnectDownload__TopHeader__backArrow}>
            {!userInfo && <img src={backArrowIcon} />}
          </div>{" "}
          <div
            className={styles.SpinConnectDownload__TopHeader__login}
            onClick={() => {
              if (topText == "LOG-IN") {
                window.location.href = window.location.origin + "/enter";
              } else {
                window.location.href = window.location.origin + "/subscription";
              }
            }}
          >
            <a
              target="_blank"
              className={styles.SpinConnectDownload__TopHeader__login__link}
            >
              {topText}
            </a>
          </div>
        </div>

        <div className={styles.SpinConnectDownload__logo}>
          <img src={spinConnectLogo} />
        </div>
        <div className={styles.SpinConnectDownload__content}>
          <div className={styles.SpinConnectDownload__content__header}>
            <div
              className={styles.SpinConnectDownload__content__header__logoTitle}
            >
              SPIN OS
            </div>
            <div
              className={
                styles.SpinConnectDownload__content__header__logoDescription
              }
            >
              Join The Smart Product Revolution
            </div>
          </div>
          <div className={styles.SpinConnectDownload__content__Downloadables}>
            <div
              className={
                styles.SpinConnectDownload__content__Downloadables__Mac
              }
            >
              <span
                className={
                  styles.SpinConnectDownload__content__Downloadables__Mac__title
                }
              >
                MAC
              </span>
              <img
                src={macIcon}
                className={
                  styles.SpinConnectDownload__content__Downloadables__Mac__Icon
                }
              />
              <div
                className={
                  styles.SpinConnectDownload__content__Downloadables__Mac__Download
                }
                onClick={handleClick}
              >
                DOWNLOAD
              </div>
            </div>
            <div
              className={
                styles.SpinConnectDownload__content__Downloadables__Window
              }
            >
              <span
                className={
                  styles.SpinConnectDownload__content__Downloadables__Window__title
                }
              >
                Windows
              </span>
              <img
                src={windowsIcon}
                className={
                  styles.SpinConnectDownload__content__Downloadables__Window__Icon
                }
              />
              <div
                className={
                  styles.SpinConnectDownload__content__Downloadables__Window__Download
                }
                onClick={() => {
                  handleClick({ fromWindows: true });
                }}
              >
                DOWNLOAD
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SpinConnectDownload;
